const reducer = (state, action) => {
  let nextState = Object.assign({}, state);

  switch (action.type) {
    case 'SET_PRODUCTS': {
      nextState.products = action.payload
      return nextState;
    }

    case 'ADD_SELECTED_PRODUCT_ID': {
      nextState.selectedProductIds.push(action.payload);
      return nextState;
    }

    case 'REMOVE_SELECTED_PRODUCT_ID': {
      nextState.selectedProductIds.splice(nextState.selectedProductIds.indexOf(action.payload), 1);
      return nextState;
    }

    default:
      return nextState;
  }
}

export default reducer;